import { createEnv } from '@t3-oss/env-nextjs';
import dotenv from 'dotenv';
import { z } from 'zod';

dotenv.config();

export const env = createEnv({
  client: {
    NEXT_PUBLIC_GATEWAY_URL: z.string().optional(),
    NEXT_PUBLIC_APP_URL: z.string().optional(),
    NEXT_PUBLIC_ROOT_DOMAIN: z.string().optional(),

    // AWS ENV
    NEXT_PUBLIC_AWS_IDENTITY_POOL_ID: z.string().optional(),
    NEXT_PUBLIC_AWS_REGION: z.string().optional(),
    NEXT_PUBLIC_AWS_MAP_NAME: z.string().optional(),
    NEXT_PUBLIC_AWS_MAP_STYLE: z.string().optional(),
    NEXT_PUBLIC_AWS_MAP_PLACE: z.string().optional(),
    NEXT_PUBLIC_AWS_MAP_GEOFENCE: z.string().optional(),
    NEXT_PUBLIC_AWS_MAP_TRACKER: z.string().optional(),
    NEXT_PUBLIC_AWS_TRACKER_SIMULATED_DEVICE: z.string().optional(),

    // AWS ENV Storefront
    NEXT_PUBLIC_AWS_STORE_IDENTITY_POOL_ID: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_REGION: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_MAP_NAME: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_MAP_STYLE: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_MAP_PLACE: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_MAP_GEOFENCE: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_MAP_TRACKER: z.string().optional(),
    NEXT_PUBLIC_AWS_STORE_TRACKER_SIMULATED_DEVICE: z.string().optional(),

    // SSO ENV
    NEXT_PUBLIC_SSO_URL: z.string().optional(),
    NEXT_PUBLIC_SSO_API: z.string().optional(),
    NEXT_PUBLIC_PROTOCOL: z.string().optional(),

    NEXT_PUBLIC_GOOGLE_API_KEY: z.string().optional(),
    NEXT_PUBLIC_SERVER_IP: z.string().optional(),

    NEXT_PUBLIC_MAP_SERVICE: z.string().optional(),
  },
  runtimeEnv: {
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL || 'https://v2-stg.jubelio.store',
    NEXT_PUBLIC_ROOT_DOMAIN: process.env.NEXT_PUBLIC_ROOT_DOMAIN || 'jubelio.store',
    NEXT_PUBLIC_GATEWAY_URL:
      process.env.NEXT_PUBLIC_GATEWAY_URL || 'https://api-gateway.staging-wv2.jubelio.com',

    // AWS ENV
    NEXT_PUBLIC_AWS_IDENTITY_POOL_ID:
      process.env.NEXT_PUBLIC_AWS_IDENTITY_POOL_ID ||
      'ap-southeast-1:386da2c2-e26d-433a-9445-e169c0a9f8c7',
    NEXT_PUBLIC_AWS_REGION: process.env.NEXT_PUBLIC_AWS_REGION || 'ap-southeast-1',
    NEXT_PUBLIC_AWS_MAP_NAME: process.env.NEXT_PUBLIC_AWS_MAP_NAME || 'GrabDemoMap',
    NEXT_PUBLIC_AWS_MAP_STYLE: process.env.NEXT_PUBLIC_AWS_MAP_STYLE || 'VectorGrabMonoStreet',
    NEXT_PUBLIC_AWS_MAP_PLACE: process.env.NEXT_PUBLIC_AWS_MAP_PLACE || 'GrabDemoPlaceIndex',
    NEXT_PUBLIC_AWS_MAP_GEOFENCE:
      process.env.NEXT_PUBLIC_AWS_MAP_GEOFENCE || 'GrabDemoGeofenceCollection',
    NEXT_PUBLIC_AWS_MAP_TRACKER: process.env.NEXT_PUBLIC_AWS_MAP_TRACKER || 'GrabDemoTrackers',
    NEXT_PUBLIC_AWS_TRACKER_SIMULATED_DEVICE:
      process.env.NEXT_PUBLIC_AWS_TRACKER_SIMULATED_DEVICE || 'Vehicle-1',

    // AWS ENV Storefront
    NEXT_PUBLIC_AWS_STORE_IDENTITY_POOL_ID:
      process.env.NEXT_PUBLIC_AWS_STORE_IDENTITY_POOL_ID ||
      'ap-southeast-1:386da2c2-e26d-433a-9445-e169c0a9f8c7',
    NEXT_PUBLIC_AWS_STORE_REGION: process.env.NEXT_PUBLIC_AWS_STORE_REGION || 'ap-southeast-1',
    NEXT_PUBLIC_AWS_STORE_MAP_NAME: process.env.NEXT_PUBLIC_AWS_STORE_MAP_NAME || 'GrabProdMap',
    NEXT_PUBLIC_AWS_STORE_MAP_STYLE:
      process.env.NEXT_PUBLIC_AWS_STORE_MAP_STYLE || 'VectorGrabMonoStreet',
    NEXT_PUBLIC_AWS_STORE_MAP_PLACE:
      process.env.NEXT_PUBLIC_AWS_STORE_MAP_PLACE || 'GrabDemoPlaceIndex',
    NEXT_PUBLIC_AWS_STORE_MAP_GEOFENCE:
      process.env.NEXT_PUBLIC_AWS_STORE_MAP_GEOFENCE || 'GrabDemoGeofenceCollection',
    NEXT_PUBLIC_AWS_STORE_MAP_TRACKER:
      process.env.NEXT_PUBLIC_AWS_STORE_MAP_TRACKER || 'GrabDemoTrackers',
    NEXT_PUBLIC_AWS_STORE_TRACKER_SIMULATED_DEVICE:
      process.env.NEXT_PUBLIC_AWS_STORE_TRACKER_SIMULATED_DEVICE || 'Vehicle-1',

    // SSO ENV
    NEXT_PUBLIC_SSO_URL: process.env.NEXT_PUBLIC_SSO_URL || 'https://oauth-staging.jubelio.com',
    NEXT_PUBLIC_SSO_API:
      process.env.NEXT_PUBLIC_SSO_API || 'https://oauth-service.staging-k8s.jubelio.com',

    NEXT_PUBLIC_PROTOCOL: process.env.NODE_ENV === 'development' ? 'http' : 'https',

    NEXT_PUBLIC_GOOGLE_API_KEY:
      process.env.NEXT_PUBLIC_GOOGLE_API_KEY || 'AIzaSyDcQ3DgsQ9kxXbdcxg6SFOFllFJjAWE4Hk',
    NEXT_PUBLIC_SERVER_IP: process.env.NEXT_PUBLIC_SERVER_IP || '139.59.217.61',

    NEXT_PUBLIC_MAP_SERVICE: process.env.NEXT_PUBLIC_MAP_SERVICE || 'https://maps-ui.jubelio.com',
  },
});
